// extracted by mini-css-extract-plugin
module.exports = {"line":"EventItem_line__1M4aD","event_item":"EventItem_event_item__1ivGC","title":"EventItem_title__Dt7Bm"};